export var colors = {
    primary: '#00F0AA',
    danger: '#EB5757',
    action: '#07285B',
    smoke: '#979797',
};
